import { Language } from './language';
import { TemplateLink } from './template-link';

export class EmailTemplate {

    constructor(
        public title: string,
        public body: string,
        public templateLinks: TemplateLink[],
        public language: Language,
        public id?: number | null
    ){}
}
